import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module,
	Button,
	FlexBox,
	FlexBoxBlock
} from 'ps-gui';

import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';

import UserAdminModel from './useradminmodel';
import { exportToExcel, getGlobalContextChangeChecker } from './utils';
import { withGlobalContext } from '../data/globalcontext';
import { getPhrase } from '../data/phrases';

const Wrapper = styled.div`
	tbody {
		tr {
			&.cancelled {
				opacity: 0.5;
			}
			td {
				font-size: 13px;
			}
		}
	}
	thead {
		tr {
			th {
				font-size: 13px;
			}
			.ps-input {
				.text {
					font-size: 13px;
				}
			}
		}
	}
`;

class UserAdminModule extends ParentBoundComponent {

	constructor() {
		super();
		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
		this.exportUsersToExcel = this.exportUsersToExcel.bind(this);
	}

	getModel() {
		return new UserAdminModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	async exportUsersToExcel() {
		exportToExcel('API_UserExcelExport', {}, 'uzivatele.xlsx');
	}

	async componentDidMount() {
		await this.checkGlobalContextChange();
	}

	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}

	render() {
		const data = this.getData();
		return (
			<Wrapper key={data.get('languageTimestamp')}>
				<FlexBox>
					<FlexBoxBlock flexGrow="1"></FlexBoxBlock>
					<FlexBoxBlock>
						<Button
							text={getPhrase('exportUsersToExcel')}
							onAction={this.exportUsersToExcel}
							type="medium"
							margin="0px 0px 16px 0px"
						/>
					</FlexBoxBlock>
				</FlexBox>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={customResultProps}
				/>
			</Wrapper>
		);
	}
}

export default withGlobalContext(UserAdminModule);

const PartyCell = styled.div`
	.party {
		margin-bottom: 4px;
		.name {
			display: inline-block;
			margin-right: 4px;
		}
		.id {
			font-size: 80%;
			font-weight: 500;
		}
	}
`;


const cellRendererMap = Object.freeze({
	'created_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('created_by')}</CellSubText>
			</>
		);
	},
	'edited_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('edited_by')}</CellSubText>
			</>
		);
	},
	parties: (cell) => {
		if (!cell) {
			return null;
		}
		return (
			<PartyCell>
				{
					cell.split('|').map((range, index) => {
						const idx = range.indexOf(';');
						if (idx < 0) {
							return null;
						}
						const id = range.substring(0, idx);
						const name = range.substring(idx + 1);
						return (
							<div key={index} className='party'>
								<span className='name'>{name}</span>
								<span className='id'>({id})</span>
							</div>
						);
					})
				}
			</PartyCell>
		);

	}
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: true,
	withRowSelection: true,
	defaultColumnWidths: {
		'activated': '114px',
		'language': '114px',
		'phone': '140px',
		'from_date': '110px',
		'to_date': '110px',
		'is_system_admin': '114px',
		'is_submission_admin': '114px',
	},
	columnFilters: {
		'is_deleted': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'is_system_admin': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'is_submission_admin': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'user_name': {
			type: 'text',
		},
		'display_name': {
			type: 'text',
		},
		'phone': {
			type: 'text',
		},
		'email': {
			type: 'text',
		},
		'language': {
			type: 'lookup',
			lookup: 'language'
		},
		'activated': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'from_date': {
			type: 'date'
		},
		'to_date': {
			type: 'date'
		},
		'parties': {
			type: 'lookup',
			lookup: 'partyIdName'
		}
	}
};

